module.exports = __webpack_public_path__ + "img/bnr_app.ba691745.png";